import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson zakłada firmę London Rubber Company i sprzedaje importowane prezerwatywy i akcesoria.',
		},
		{
			year: 1929,
			description: 'London Rubber Company (LRC) rejestruje markę Durex.',
		},
		{
			year: 'Lata 50.',
			description: 'Durex wprowadza na rynek swoją pierwszą nawilżaną prezerwatywę.',
		},
		{
			year: 1953,
			description: 'Durex jest pierwszą marką, która opracowała i zastosowała testy elektroniczne.',
		},
		{
			year: 'Lata 60.',
			description: 'Durex wprowadza na rynek pierwszą prezerwatywę o anatomicznym kształcie.',
		},
		{
			year: 'Lata 70.',
			description: 'Durex jest pierwszą marką prezerwatyw na świecie, która reklamuje się w wielu krajach.',
		},
		{
			year: 'Lata 90.',
			description: 'Durex jest pierwszą marką prezerwatyw, która jako standard wprowadziła globalny "znak jakości".',
		},
		{
			year: 1995,
			description: 'Durex wprowadza na rynek serię kolorowych, smakowych prezerwatyw.',
		},
		{
			year: 1996,
			description: 'Durex jest pierwszą marką prezerwatyw, która stworzyła stronę internetową. Obecnie posiadamy 42 różne strony internetowe dla krajów, w których prowadzimy działalność.',
		},
		{
			year: 1997,
			description: 'Durex wprowadza do sprzedaży nielateksowe prezerwatywy. W produktach zastosowano nowy, niealergiczny materiał: syntetyczny poliuretan opracowany przez Durex jest bardziej miękki i elastyczny niż lateks z kauczuku naturalnego.',
		},
		{
			year: 1998,
			description: 'Durex jest pierwszą marką prezerwatyw, która przeprowadziła i opublikowała ogólnoświatową ankietę na temat zadowolenia z życia seksualnego. ',
		},
		{
			year: 2001,
			description: 'Durex wprowadza na rynek prezerwatywę Pleasuremax i staje się pierwszą marką prezerwatyw, która wprowadziła na rynek prezerwatywę z prążkami i wypustkami.',
		},
		{
			year: 2003,
			description: 'Durex wprowadza na rynek ekscytującą gamę żeli intymnych Play.',
		},
		{
			year: 2005,
			description: 'Durex Network wprowadza na rynek raporty Face of Global Sex, które badają aspekty zachowań seksualnych i są tworzone na potrzeby pracowników naukowych i decydentów politycznych.',
		},
		{
			year: 2008,
			description: 'W celu promowania bezpiecznego seksu wśród młodych ludzi, Durex zachęca młodych ludzi w wieku od 16 do 24 lat do stworzenia unikalnego plakatu na temat zdrowia seksualnego - plakatu młodzieżowego dla nastolatków.',
		},
		{
			year: 2009,
			description: 'Durex świętuje 80-lecie swojego istnienia!',
		},
		{
			year: 2010,
			description: 'Durex wspiera inicjatywę "Condomize!" Funduszu Ludnościowego ONZ na Międzynarodowej Konferencji AIDS w Wiedniu, przekazując 220 000 prezerwatyw.',
		},
		{
			year: 2010,
			description: 'Durex zostaje zakupiony przez firmę Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex wprowadza na rynek Performax Intense (Mutual Pleasure), prezerwatywę zaprojektowaną, aby ułatwić wspólne osiągnięcie orgazmu przez oboje partnerów. Dzięki wewnętrznej powłoce lubrykantu zawierającego 5% benzokainy i stymulującej strukturze zewnętrznej, prezerwatywa pomaga wydłużyć stosunek i zapewnić bardziej intensywne doznania.',
		},
		{
			year: 2019,
			description: 'Durex świętuje 90-lecie swojego istnienia!',
		},
	]
}